import "reflect-metadata"
import { ApplicationEntity } from "./application-entity"

export function FieldDescriptor(fieldDescription: FieldDescription) {
  return (target: object, property: string) => {
    const properties: string[] = Reflect.getMetadata("properties", target) || []
    properties.push(property)
    Reflect.defineMetadata("properties", properties, target)

    if (
      exists(fieldDescription.selectionFieldDescription) &&
      exists(fieldDescription.selectionFieldDescription!.valuesInitializer)
    ) {
      fieldDescription.selectionFieldDescription!.valuesInitializer!(fieldDescription.selectionFieldDescription!.values)
    }

    fieldDescription.fieldName = property

    if (!exists(fieldDescription.displayed)) {
      fieldDescription.displayed = true
    }

    if (!exists(fieldDescription.isFilterable)) {
      fieldDescription.isFilterable = false
    }

    if (!exists(fieldDescription.hasTime)) {
      fieldDescription.hasTime = false
    }

    if (!exists(fieldDescription.fixed)) {
      fieldDescription.fixed = false
    }

    if (!exists(fieldDescription.sortable)) {
      fieldDescription.sortable = false
    }

    Reflect.defineMetadata("fieldDescriptors", fieldDescription, target, property)
  }
}

export function getFieldDescriptor(target: object, property: string) {
  return Reflect.getMetadata("fieldDescriptors", target, property)
}

export function getProperties(target: object) {
  return Reflect.getMetadata("properties", target)
}

export const enum FieldTypeEnum {
  TEXT = "TEXT",
  NUMBER = "NUMBER",
  AUTOCOMPLETE = "AUTOCOMPLETE",
  BOOLEAN = "BOOLEAN",
  DATE = "DATE",
  SELECT = "SELECT"
}

export interface SelectionFieldDescription {
  displayKey?: string
  valueKey?: string
  values: any[]
  i18n: boolean
  valuesInitializer?(values: ApplicationEntity[] | string[]): void
}

export interface FieldDescription {
  fieldName?: string
  fieldType: FieldTypeEnum
  fieldPrettyName?: string
  columnWidth?: string
  isFilterable?: boolean
  isRequired?: boolean
  displayed?: boolean
  selectionFieldDescription?: SelectionFieldDescription
  autocompleteFieldApi?: any
  hasTime?: boolean
  fixed?: boolean
  sortable?: boolean
  defaultSort?: string
}
